import { NotificationEnum } from '../../../models/notificationEnum';
import { RecipientEnum } from '../../../models/recipientEnum';
import { TemplateTranslation } from '../../../models/translation';

export const templatesEn: TemplateTranslation = {
  locale: 'en',
  templates: {
    [NotificationEnum.ACCEPTED_TIME_TRACKING]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Working time has been approved',
          body: {
            introText:
              'Your recorded working time has been approved for the following service:',
          },
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Working time has been approved',
          body: {
            introText:
              'The recorded working time has been approved for the following service:',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Working time has been approved',
          body: {
            introText:
              'The recorded working time has been approved for the following service:',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Working time has been approved',
          body: {
            introText:
              'The recorded working time has been approved for the following service:',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Working time has been approved',
          body: {
            introText:
              'The recorded working time has been approved for the following service:',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Working time has been approved',
          body: {
            introText:
              'The recorded working time has been approved for the following service:',
          },
        },
      },
      [RecipientEnum.ORGANISATION]: {
        EMAIL: {
          subject: 'IN-POOL - Working time has been approved',
          body: {
            introText:
              'The recorded working time has been approved for the following service:',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Working time has been approved',
          body: {
            introText:
              'The recorded working time has been approved for the following service:',
          },
        },
      },
    },
    [NotificationEnum.ACTION_REQUIRED_ACCEPT_INVITEE]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Service has a new acceptance',
          body: {
            introText: 'The following service has a new acceptance:',
            textBeforeAction: 'Accept the desired employee:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Service has a new acceptance',
          body: {
            introText: 'The following service has a new acceptance:',
            textBeforeAction: 'Accept the desired employee:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Service has a new acceptance',
          body: {
            introText: 'The following service has a new acceptance:',
            textBeforeAction: 'Accept the desired employee:',
            actionButtonText: 'Go to Service',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_ACTION_REQUIRED_ACCEPT_INVITEE]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Assignment has a new acceptance',
          body: {
            introText: 'The following assignment has a new acceptance:',
            textBeforeAction: 'Accept the desired employee:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Assignment has a new acceptance',
          body: {
            introText: 'The following assignment has a new acceptance:',
            textBeforeAction: 'Accept the desired employee:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Assignment has a new acceptance',
          body: {
            introText: 'The following assignment has a new acceptance:',
            textBeforeAction: 'Accept the desired employee:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
    },
    [NotificationEnum.ACTION_REQUIRED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Service has no employees',
          body: {
            introText:
              'No employees have been invited for the following service or all invited employees have declined:',
            textBeforeAction: 'If possible, invite more employees:',
            actionButtonText: 'Go to Service',
          },
        },
        PUSH: {
          title: 'IN-POOL - Service has no employees',
          body: 'All invited employees have declined: {{job.department.displayName}} on {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Service has no employees',
          body: {
            introText:
              'No employees have been invited for the following service or all invited employees have declined:',
            textBeforeAction: 'If possible, invite more employees:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Service has no employees',
          body: {
            introText:
              'No employees have been invited for the following service or all invited employees have declined:',
            textBeforeAction: 'If possible, invite more employees:',
            actionButtonText: 'Go to Service',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_ACTION_REQUIRED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Assignment has no employees',
          body: {
            introText:
              'No employees have been invited for the following assignment or all invited employees have declined:',
            textBeforeAction: 'If possible, invite more employees:',
            actionButtonText: 'Go to Assignment',
          },
        },
        PUSH: {
          title: 'IN-POOL - Assignment has no employees',
          body: 'All invited employees have declined: {{employment.department.displayName}} for {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Assignment has no employees',
          body: {
            introText:
              'No employees have been invited for the following assignment or all invited employees have declined:',
            textBeforeAction: 'If possible, invite more employees:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
    },
    [NotificationEnum.ADD_TIME_TRACKING]: {
      [RecipientEnum.USER]: {
        SMS: 'Time tracking missing: for {{departmentName}} \nTo Dashboard: {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Record Working Time',
          body: {
            introText:
              'No working hours have been recorded for the following service:',
            textBeforeAction: 'Please complete this as soon as possible:',
            actionButtonText: 'Go to Time Tracking',
          },
        },
        PUSH: {
          title: 'IN-POOL - Record Working Time',
          body: 'Time tracking missing: {{job.department.displayName}} on {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.EXTERNAL_USER]: {
        EMAIL: {
          subject: 'IN-POOL - Record Working Time',
          body: {
            introText: 'Record your working time for the following service:',
            textBeforeAction: 'Use the following link:',
            actionButtonText: 'Go to Time Tracking',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_FOR_CREATOR]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Approve Working Time',
          body: {
            introText:
              'The recorded working time has been submitted for approval for the following service:',
            textBeforeAction:
              'Please check and approve the recorded working time:',
            actionButtonText: 'Go to Time Tracking',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Approve Working Time',
          body: {
            introText:
              'The recorded working time has been submitted for approval for the following service:',
            textBeforeAction:
              'Please check and approve the recorded working time:',
            actionButtonText: 'Go to Time Tracking',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_FOR_HOSPITAL]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Approve Working Time',
          body: {
            introText:
              'The recorded working time has been submitted for approval for the following service:',
            textBeforeAction:
              'Please check and approve the recorded working time:',
            actionButtonText: 'Go to Time Tracking',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Approve Working Time',
          body: {
            introText:
              'The recorded working time has been submitted for approval for the following service:',
            textBeforeAction:
              'Please check and approve the recorded working time:',
            actionButtonText: 'Go to Time Tracking',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_FOR_AGENCY]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Approve Working Time',
          body: {
            introText:
              'The recorded working time has been submitted for approval for the following service:',
            textBeforeAction:
              'Please check and approve the recorded working time:',
            actionButtonText: 'Go to Time Tracking',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_REMINDER_FOR_CREATOR]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Approve Working Time',
          body: {
            introText:
              'The recorded working time has not yet been approved for the following service:',
            textBeforeAction: 'Please complete this as soon as possible:',
            actionButtonText: 'Go to Time Tracking',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Approve Working Time',
          body: {
            introText:
              'The recorded working time has not yet been approved for the following service:',
            textBeforeAction: 'Please complete this as soon as possible:',
            actionButtonText: 'Go to Time Tracking',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_REMINDER_FOR_HOSPITAL]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Approve Working Time',
          body: {
            introText:
              'The recorded working time has not yet been approved for the following service:',
            textBeforeAction: 'Please complete this as soon as possible:',
            actionButtonText: 'Go to Time Tracking',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Approve Working Time',
          body: {
            introText:
              'The recorded working time has not yet been approved for the following service:',
            textBeforeAction: 'Please complete this as soon as possible:',
            actionButtonText: 'Go to Time Tracking',
          },
        },
      },
    },
    [NotificationEnum.APPROVE_TIME_TRACKING_REMINDER_FOR_AGENCY]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Approve Working Time',
          body: {
            introText:
              'The recorded working time has not yet been approved for the following service:',
            textBeforeAction: 'Please complete this as soon as possible:',
            actionButtonText: 'Go to Time Tracking',
          },
        },
      },
    },
    [NotificationEnum.BOOKED_INTERNAL]: {
      [RecipientEnum.USER]: {
        SMS: 'You have been booked by {{customerName}}: {{departmentName}} \nTo Dashboard: {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Booked: {{{job.department.displayName}}}',
          body: {
            introText:
              'You have been booked by {{customerName}} for the following service:',
            outroText: 'The calendar entry can be found in the attachment',
            actionButtonText: 'To Dashboard',
          },
        },
        PUSH: {
          title: 'IN-POOL - Booked: {{job.department.displayName}}',
          body: 'You have been booked by {{customerName}}: {{job.department.displayName}} on {{job.date}}{{#invitee.partialTimes}} / {{from}} - {{to}} {{/invitee.partialTimes}}{{^invitee.partialTimes}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}{{/invitee.partialTimes}}',
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Booked {{user.firstName}} {{user.lastName}} on {{job.date}} at {{job.department.displayName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following service:',
            actionButtonText: 'Go to Service',
          },
        },
        PUSH: {
          title:
            'IN-POOL - Booked {{user.firstName}} {{user.lastName}} on {{job.date}} at {{job.department.displayName}}',
          body: 'A person from {{customerName}} has been booked for the following service: {{job.department.displayName}} on {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Booked {{user.firstName}} {{user.lastName}} on {{job.date}} at {{job.department.displayName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Booked {{user.firstName}} {{user.lastName}} on {{job.date}} at {{job.department.displayName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.SHARED_POOL_OWNER]: {
        EMAIL: {
          subject:
            'IN-POOL - Booked {{user.firstName}} {{user.lastName}} on {{job.date}} at {{job.department.displayName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Booked {{user.firstName}} {{user.lastName}} on {{job.date}} at {{job.department.displayName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Booked {{user.firstName}} {{user.lastName}} on {{job.date}} at {{job.department.displayName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.ORGANISATION]: {
        EMAIL: {
          subject:
            'IN-POOL - Booked {{user.firstName}} {{user.lastName}} on {{job.date}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject:
            'IN-POOL - Booked {{user.firstName}} {{user.lastName}} on {{job.date}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_BOOKED_INTERNAL]: {
      [RecipientEnum.USER]: {
        SMS: 'You have been booked by {{customerName}}: {{departmentName}} \nTo Dashboard: {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Booked: {{{employment.department.displayName}}}',
          body: {
            introText:
              'You have been booked by {{customerName}} for the following temporary assignment:',
            outroText: 'The calendar entry can be found in the attachment',
            actionButtonText: 'To Dashboard',
          },
        },
        PUSH: {
          title: 'IN-POOL - Booked: {{employment.department.displayName}}',
          body: 'You have been booked by {{customerName}}: {{employment.department.displayName}} for {{formattedDate}}',
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Booked {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following assignment:',
            actionButtonText: 'Go to Assignment',
          },
        },
        PUSH: {
          title: 'IN-POOL - Booked {{user.firstName}} {{user.lastName}}',
          body: 'A person from {{customerName}} has been booked for the following assignment: {{employment.department.displayName}} for {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Booked {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following assignment:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Booked {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following assignment:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Booked {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following assignment:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
      [RecipientEnum.SHARED_POOL_OWNER]: {
        EMAIL: {
          subject: 'IN-POOL - Booked {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following assignment:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Booked {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following assignment:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
    },
    [NotificationEnum.BOOKED_EXTERNAL]: {
      [RecipientEnum.EXTERNAL_USER]: {
        EMAIL: {
          subject: 'IN-POOL - Booked: {{{job.department.displayName}}}',
          body: {
            introText:
              'You have been booked by {{customerName}} for the following service:',
            outroText:
              'For time tracking, you will automatically receive an email with a link shortly before the service starts, with which you can record your hours digitally.',
          },
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Booked {{user.firstName}} {{user.lastName}} on {{job.date}} at {{job.department.displayName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following service:',
            actionButtonText: 'Go to Service',
          },
        },
        PUSH: {
          title:
            'IN-POOL - Booked {{user.firstName}} {{user.lastName}} on {{job.date}} at {{job.department.displayName}}',
          body: 'A person from {{customerName}} has been booked for the following service: {{job.department.displayName}} on {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Booked {{user.firstName}} {{user.lastName}} on {{job.date}} at {{job.department.displayName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject:
            'IN-POOL - Booked {{user.firstName}} {{user.lastName}} on {{job.date}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_BOOKED_EXTERNAL]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Booked {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following assignment:',
            actionButtonText: 'Go to Assignment',
          },
        },
        PUSH: {
          title: 'IN-POOL - Booked {{user.firstName}} {{user.lastName}}',
          body: 'A person from {{customerName}} has been booked for the following assignment: {{employment.department.displayName}} for {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Booked {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following assignment:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Booked {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'A person from {{customerName}} has been booked for the following assignment:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
    },
    [NotificationEnum.DECLINED]: {
      [RecipientEnum.USER]: {
        SMS: 'A service has already been assigned to another person:\n{{departmentName}}',
        EMAIL: {
          subject: 'IN-POOL - Rejection for {{{job.department.displayName}}}',
          body: {
            introText:
              'The following service has already been assigned to another person:',
          },
        },
        PUSH: {
          title: 'IN-POOL - Rejection for {{job.department.displayName}}',
          body: 'The following service has already been assigned to another person: {{job.department.displayName}} on {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Rejection {{user.firstName}} {{user.lastName}}',
          body: {
            introText: 'A person has been rejected for the following service:',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Rejection {{user.firstName}} {{user.lastName}}',
          body: {
            introText: 'A person has been rejected for the following service:',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Rejection {{user.firstName}} {{user.lastName}}',
          body: {
            introText: 'A person has been rejected for the following service:',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Rejection {{user.firstName}} {{user.lastName}}',
          body: {
            introText: 'A person has been rejected for the following service:',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_INVITEE_DECLINED]: {
      [RecipientEnum.USER]: {
        SMS: 'A temporary assignment has already been assigned to another person:\n{{departmentName}}',
        EMAIL: {
          subject:
            'IN-POOL - Rejection for {{{employment.department.displayName}}}',
          body: {
            introText:
              'The following temporary assignment has already been assigned to another person:',
          },
        },
        PUSH: {
          title:
            'IN-POOL - Rejection for {{employment.department.displayName}}',
          body: 'The following temporary assignment has already been assigned to another person: {{employment.department.displayName}} for {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Rejection {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'A person has been rejected for the following assignment:',
          },
        },
      },
    },
    [NotificationEnum.ENROLL_POOLER_ACCOUNT]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Welcome to the {{{customerName}}} Pool',
          body: {
            introText: 'We are pleased to welcome you to inpool.',
            actionButtonPreText:
              'Please activate your account by setting your password with the following link:',
            actionButtonText: 'Activate Account',
            actionButtonPostText: 'This link is valid only once.',
            secondaryActionPreText:
              'You can log in with your email address and the chosen password in the future. Please use this link',
            secondaryActionText: 'Login',
          },
        },
      },
    },
    [NotificationEnum.ENROLL_DISPO_ACCOUNT]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Welcome',
          body: {
            introText: 'We are pleased to welcome you to inpool.',
            actionButtonPreText:
              'Please activate your account by setting your password with the following link:',
            actionButtonText: 'Activate Account',
            actionButtonPostText: 'This link is valid only once.',
            secondaryActionPreText:
              'You can log in with your email address and the chosen password in the future. Please use this link',
            secondaryActionText: 'Login',
          },
        },
      },
    },
    [NotificationEnum.ENROLL_DEMO_ACCOUNT]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'Inpool Demo - Set Password',
          body: {
            introText:
              'Welcome to the inpool demo! Your demo environment is ready.',
            actionButtonPreText:
              'To start exploring the demo, please set your password with the following link: ',
            actionButtonText: 'Set Password',
            actionButtonPostText:
              'This link is valid only once. After setting your password, you can fully explore the demo.',
            secondaryActionPreText:
              'After setting your password, you can log in anytime with your email address. Use this link',
            secondaryActionText: 'To Demo',
          },
        },
      },
    },
    [NotificationEnum.DEMO_WELCOME]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'Welcome to the Demo',
          body: {
            introText: 'Welcome to the Demo!',
            actionButtonPreText:
              'You can log in in the future via the following link:',
            actionButtonText: 'To Demo',
            actionButtonPostText: '',
          },
        },
      },
    },
    [NotificationEnum.ENROLLMENT_COMPLETED_POOLER]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Collaboration Request Accepted',
          body: {
            introText:
              'A {{userRole}} has accepted your collaboration request and logged in for the first time.',
          },
        },
      },
    },
    [NotificationEnum.ENROLLMENT_COMPLETED_DISPO]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Collaboration Request Accepted',
          body: {
            introText:
              'A {{userRole}} has accepted your collaboration request and logged in for the first time.',
          },
        },
      },
    },
    [NotificationEnum.ENROLL_PHONE]: {
      [RecipientEnum.USER]: {
        SMS: 'To receive future requests via SMS, you must confirm your number using the following link:\n{{actionLink}}',
      },
    },
    [NotificationEnum.AUTO_ENROLL_ACCOUNT]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Welcome',
          body: {
            introText: 'We are pleased to welcome you to inpool.',
            actionButtonText: 'Login',
            actionButtonPreText:
              'You can log in with your existing Windows or Microsoft login at the following address:',
            outroText:
              "The following steps are necessary: <ul><li> Enter your email address. </li><li> You will be automatically redirected to your company's login page. Log in there with your existing login. </li><li> You will be automatically logged in to inpool</li></ul>",
          },
        },
      },
    },
    [NotificationEnum.EXTERNAL_API_REQUEST_FAILED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - API Request Failed',
          body: {
            introText:
              'There was an error with an API request, here are the details of the request:',
          },
        },
      },
    },
    [NotificationEnum.INVITEE_CANCELED]: {
      [RecipientEnum.USER]: {
        SMS: 'A service has been canceled: {{departmentName}}',
        EMAIL: {
          subject: 'IN-POOL - Cancellation: {{{job.department.displayName}}}',
          body: {
            introText: 'The following service has been canceled:',
          },
        },
        PUSH: {
          title: 'IN-POOL - Cancellation: {{job.department.displayName}}',
          body: 'Service has been canceled: {{job.department.displayName}} on {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'The following employee from {{customerName}} has been canceled for the service:',
            actionButtonText: 'Go to Service',
          },
        },
        PUSH: {
          title: 'IN-POOL - Cancellation {{user.firstName}} {{user.lastName}}',
          body: 'The following employee from {{customerName}} has been canceled for the service: {{job.department.displayName}} on {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'The following employee from {{customerName}} has been canceled for the service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'The following employee has been canceled for the service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'The following employee has been canceled for the service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'The following employee has been canceled for the service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.SHARED_POOL_OWNER]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'The following employee has been canceled for the service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.ORGANISATION]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'The following employee from {{customerName}} has been canceled for the service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'The following employee from {{customerName}} has been canceled for the service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_INVITEE_CANCELED]: {
      [RecipientEnum.USER]: {
        SMS: 'A temporary assignment has been canceled: {{departmentName}}',
        EMAIL: {
          subject:
            'IN-POOL - Cancellation: {{{employment.department.displayName}}}',
          body: {
            introText: 'The following temporary assignment has been canceled:',
          },
        },
        PUSH: {
          title:
            'IN-POOL - Cancellation: {{employment.department.displayName}}',
          body: 'Temporary assignment has been canceled: {{employment.department.displayName}} for {{formattedDate}}',
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'The following employee from {{customerName}} has been canceled for the assignment:',
          },
        },
        PUSH: {
          title: 'IN-POOL - Cancellation {{user.firstName}} {{user.lastName}}',
          body: 'The following employee from {{customerName}} has been canceled for the assignment: {{employment.department.displayName}} for {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'The following employee from {{customerName}} has been canceled for the assignment:',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'The following employee has been canceled for the assignment:',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'The following employee has been canceled for the assignment:',
          },
        },
      },
      [RecipientEnum.SHARED_POOL_OWNER]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'The following employee has been canceled for the assignment:',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'The following employee from {{customerName}} has been canceled for the assignment:',
          },
        },
      },
    },
    [NotificationEnum.INVITEE_REPLACED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Replacement for {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'The following employee has been replaced for this service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Replacement for {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'The following employee has been replaced for this service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
    },
    [NotificationEnum.INVITE]: {
      [RecipientEnum.USER]: {
        SMS: 'Service request from {{customerName}}: {{departmentName}} \nTo Dashboard: {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Request: {{{job.department.displayName}}}',
          body: {
            introText:
              'You have received the following service request from {{customerName}}:',
            actionButtonText: 'To Dashboard',
          },
        },
        PUSH: {
          title: 'IN-POOL - Request: {{job.department.displayName}}',
          body: 'Service request from {{customerName}}: {{job.department.displayName}} on {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_INVITE]: {
      [RecipientEnum.USER]: {
        SMS: 'Temporary assignment from {{customerName}}: {{departmentName}} \nTo Dashboard: {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Request: {{{employment.department.displayName}}}',
          body: {
            introText:
              'You have received the following temporary assignment request from {{customerName}}:',
            actionButtonText: 'To Dashboard',
          },
        },
        PUSH: {
          title: 'IN-POOL - Request: {{employment.department.displayName}}',
          body: 'Temporary assignment from {{customerName}}: {{employment.department.displayName}} for {{formattedDate}}',
        },
      },
    },
    [NotificationEnum.JOB_CANCELED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Cancellation: {{{job.department.displayName}}}',
          body: {
            introText: 'The following service has been canceled:',
            actionButtonText: 'Go to Service',
          },
        },
        PUSH: {
          title: 'IN-POOL - Cancellation: {{{job.department.displayName}}}',
          body: 'The following service has been canceled: {{job.department.displayName}} on {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Cancellation: {{{job.department.displayName}}}',
          body: {
            introText: 'The following service has been canceled:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Cancellation: {{{job.department.displayName}}}',
          body: {
            introText: 'The following service has been canceled:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.TRANSFER_EDITOR]: {
        EMAIL: {
          subject: 'IN-POOL - Cancellation: {{{job.department.displayName}}}',
          body: {
            introText: 'The following service has been canceled:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Cancellation: {{{job.department.displayName}}}',
          body: {
            introText: 'The following service has been canceled:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Cancellation: {{{job.department.displayName}}}',
          body: {
            introText: 'The following service has been canceled:',
            actionButtonText: 'Go to Service',
          },
        },
      },
    },
    [NotificationEnum.JOB_DECLINED]: {
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Job declined: {{{job.department.displayName}}}',
          body: {
            introText: 'The following service has been declined:',
            actionButtonText: 'Go to Service',
          },
        },
      },
    },
    [NotificationEnum.JOB_CLOSED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Service Completed: {{{job.department.displayName}}}',
          body: {
            introText: 'The following service has been completed:',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Service Completed: {{{job.department.displayName}}}',
          body: {
            introText: 'The following service has been completed:',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Service Completed: {{{job.department.displayName}}}',
          body: {
            introText: 'The following service has been completed:',
          },
        },
      },
    },
    [NotificationEnum.JOB_REOPENED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Service Reopened: {{{job.department.displayName}}}',
          body: {
            introText: 'The following service has been reopened:',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject:
            'IN-POOL - Service Reopened: {{{job.department.displayName}}}',
          body: {
            introText: 'The following service has been reopened:',
          },
        },
      },
    },
    [NotificationEnum.JOB_REOPENED_INVITE]: {
      [RecipientEnum.USER]: {
        SMS: 'Service reopened – request from {{customerName}}: {{departmentName}} \nTo Dashboard: {{actionLink}}',
        EMAIL: {
          subject:
            'IN-POOL - Request (reopened): {{{job.department.displayName}}}',
          body: {
            introText:
              'The following service has been reopened. You have received the following service request from {{customerName}}:',
            actionButtonText: 'To Dashboard',
          },
        },
        PUSH: {
          title: 'IN-POOL - Request (reopened): {{job.department.displayName}}',
          body: 'Service reopened – request from {{customerName}}: {{job.department.displayName}} on {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
    },
    [NotificationEnum.JOB_REOPENED_TRANSFER]: {
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: '{{{customerName}}} - Service Transmission (reopened)',
          body: {
            introText:
              'The following service has been reopened. {{customerName}} would like to send you the following service via email again:',
            actionButtonText: 'Go to Service',
          },
        },
        PUSH: {
          title: '{{{customerName}}} - Service Transmission (reopened)',
          body: '{{customerName}} would like to send you the following service again (reopened)',
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'Service Transmission (reopened): {{#job}}{{#department}}{{{displayName}}}{{/department}} on {{date}}{{#shifts}} / {{from}} - {{to}} {{/shifts}}{{/job}}',
          body: {
            introText:
              'The following service has been reopened. {{customerName}} would like to send you the following service via email again:',
            bookingButtonText: 'To Request',
            submitButtonText: 'To Request',
            bookingButtonMessage:
              'To book or decline a possible employee, use the following link:',
            submitButtonMessage:
              'To submit or decline a possible employee, use the following link:',
          },
        },
      },
    },
    [NotificationEnum.JOB_MISSED]: {
      [RecipientEnum.OTHER_TRANSFER_EDITORS]: {
        EMAIL: {
          subject:
            'IN-POOL - Otherwise Assigned {{{job.department.displayName}}} on {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
          body: {
            introText: 'The following service has been otherwise assigned:',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Otherwise Assigned {{{job.department.displayName}}} on {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
          body: {
            introText: 'The following service has been otherwise assigned:',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Otherwise Assigned {{{job.department.displayName}}} on {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
          body: {
            introText: 'The following service has been otherwise assigned:',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_CANCELED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation: {{{employment.department.displayName}}}',
          body: {
            introText: 'The following temporary assignment has been canceled:',
            actionButtonText: 'Go to Assignment',
          },
        },
        PUSH: {
          title:
            'IN-POOL - Cancellation: {{{employment.department.displayName}}}',
          body: 'The following temporary assignment has been canceled: {{employment.department.displayName}} for {{formattedDate}}',
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation: {{{employment.department.displayName}}}',
          body: {
            introText: 'The following temporary assignment has been canceled:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation: {{{employment.department.displayName}}}',
          body: {
            introText: 'The following temporary assignment has been canceled:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation: {{{employment.department.displayName}}}',
          body: {
            introText: 'The following temporary assignment has been canceled:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Cancellation: {{{employment.department.displayName}}}',
          body: {
            introText: 'The following temporary assignment has been canceled:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_CLOSED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Assignment Completed: {{{employment.department.displayName}}}',
          body: {
            introText: 'The following temporary assignment has been completed:',
          },
        },
      },
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Assignment Completed: {{{employment.department.displayName}}}',
          body: {
            introText: 'The following temporary assignment has been completed:',
          },
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Assignment Completed: {{{employment.department.displayName}}}',
          body: {
            introText: 'The following temporary assignment has been completed:',
          },
        },
      },
      [RecipientEnum.OTHER_TRANSFER_EDITORS]: {
        EMAIL: {
          subject:
            'IN-POOL - Otherwise Assigned {{{employment.department.displayName}}} for {{formattedDate}}',
          body: {
            introText:
              'The following temporary assignment has been otherwise assigned:',
          },
        },
      },
    },
    [NotificationEnum.NEW_ACCOUNT_PHONE_TOKEN]: {
      [RecipientEnum.USER]: {
        SMS: 'IN-POOL - Your confirmation code:\n{{secret}}',
      },
    },
    [NotificationEnum.EMAIL_OPT_IN]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Email Changed',
          body: {
            actionButtonPreText:
              'You have changed your email address. <br />Please confirm the change using the following link:',
            actionButtonText: 'Confirm',
          },
        },
      },
    },
    [NotificationEnum.PHONE_OPT_IN]: {
      [RecipientEnum.USER]: {
        SMS: 'You have changed your number. Please confirm the change using the following link:\n{{actionLink}}',
      },
    },
    [NotificationEnum.ORGANISATION_REQUEST]: {
      [RecipientEnum.USER]: {
        SMS: 'New location from {{customerName}}.\nPlease accept or decline: {{actionLink}}',
        EMAIL: {
          subject: 'Offer for a new location',
          body: {
            actionButtonPreText: `{{customerName}} offers you assignments at a new location. <br />You can accept or decline our offer on your dashboard.`,
            actionButtonText: 'To Dashboard',
          },
        },
        PUSH: {
          title: 'Offer for a new location',
          body: 'New location from {{customerName}}. Please accept or decline.',
        },
      },
    },
    [NotificationEnum.POOL_ACCEPTED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Collaboration Request Accepted',
          body: {
            introText:
              'A {{userRole}} has accepted your collaboration request.',
            actionButtonText: 'To Employee',
          },
        },
      },
    },
    [NotificationEnum.POOL_DECLINED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Collaboration Request Declined',
          body: {
            introText:
              'A {{userRole}} has declined your collaboration request.',
          },
        },
      },
    },
    [NotificationEnum.POOLER_INVITE_REMINDER]: {
      [RecipientEnum.USER]: {
        SMS: 'Reminder: Invitation at {{departmentName}} is still pending',
        EMAIL: {
          subject: 'Reminder - Invitation at {{{job.department.displayName}}}',
          body: {
            introText: 'Your response is pending for the following service:',
            actionButtonText: 'To Dashboard',
          },
        },
        PUSH: {
          title: 'Reminder - Invitation at {{job.department.displayName}}',
          body: 'Invitation at {{job.department.displayName}} on {{job.date}} is still pending',
        },
      },
    },
    [NotificationEnum.POOLER_JOB_REMINDER]: {
      [RecipientEnum.USER]: {
        SMS: 'Reminder: Assignment at {{departmentName}} on {{jobDate}} starts at {{jobStartTime}}',
        EMAIL: {
          subject: 'Reminder - Assignment at {{{job.department.displayName}}}',
          body: {
            introText: 'The following service will begin shortly:',
          },
        },
        PUSH: {
          title: 'Reminder - Assignment at {{job.department.displayName}}',
          body: 'Assignment at {{job.department.displayName}} on {{job.date}} starts at {{jobStartTime}}',
        },
      },
    },
    [NotificationEnum.POOLER_TRANSFERRED]: {
      [RecipientEnum.USER]: {
        SMS: 'You have been rescheduled for the service to {{departmentName}} \nTo Dashboard: {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Rescheduled: to {{{job.department.displayName}}}',
          body: {
            introText: 'You have been rescheduled for the following service:',
            from: 'From',
            to: 'To',
          },
        },
        PUSH: {
          title: 'IN-POOL - Rescheduled: to {{job.department.displayName}}',
          body: 'You have been rescheduled for the service on {{job.date}} to {{job.department.displayName}} on {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
      },
    },
    [NotificationEnum.POOL_REMOVED]: {
      [RecipientEnum.USER]: {
        SMS: 'We confirm that you have been removed from our pool and your data has been deleted.',
        EMAIL: {
          subject: 'IN-POOL - Unsubscription: {{{customerName}}} Pool',
          body: {
            introText:
              'We confirm that you have been unsubscribed from our pool and your related data has been deleted.',
            outroText:
              'If you have any questions, please feel free to contact us.',
          },
        },
        PUSH: {
          title: 'IN-POOL - Unsubscription: {{customerName}} Pool',
          body: 'We confirm that you have been unsubscribed from our pool and your related data has been deleted.',
        },
      },
    },
    [NotificationEnum.POOL_REQUEST]: {
      [RecipientEnum.USER]: {
        SMS: '{{customerName}} wants to add you to the pool.\nAccept or decline request: {{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - Pool Request',
          body: {
            introText: `{{customerName}} wants to add you to the pool.<br />You can accept or decline this request on your dashboard.`,
            actionButtonText: 'To Dashboard',
          },
        },
        PUSH: {
          title: 'IN-POOL - Pool Request',
          body: '{{customerName}} wants to add you to the pool. Accept or decline request.',
        },
        SYS: '',
      },
    },
    [NotificationEnum.POSSIBLE_CANDIDATE]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - New Possible Employee',
          body: {
            introText:
              'A possible employee has been submitted for the following service:',
            textBeforeAction: 'Accept the desired employee:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - New Possible Employee',
          body: {
            introText:
              'A possible employee has been submitted for the following service:',
            textBeforeAction: 'Accept the desired employee:',
            actionButtonText: 'Go to Service',
          },
        },
      },
    },
    [NotificationEnum.PROFILE_INFO_CHANGED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Pooler Updated Data',
          body: {
            introText: 'The following data for {{userName}} has been updated:',
            changedByEditor: 'The data was changed by {{editorName}}.',
            changedByDifferentCustomer:
              'The data was changed by a different customer.',
          },
          changedInfoKeys: {
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email',
            sex: 'Sex',
            phone: 'Phone',
            notifyEmail: 'Email Notification',
            notifySms: 'SMS Notification',
            shifts: 'Shifts',
            jobTypes: 'Job Types',
          },
        },
      },
    },
    [NotificationEnum.REASK]: {
      [RecipientEnum.USER]: {
        SMS: 'Response is pending this is a long text to test the shortening abc lorem ipsum abc test test: {{departmentName}}  \nTo Dashboard: {{actionLink}}',
        EMAIL: {
          subject:
            'IN-POOL - Response Pending: {{{job.department.displayName}}}',
          body: {
            introText: 'Your response is pending for the following service:',
            actionButtonText: 'To Dashboard',
          },
        },
        PUSH: {
          title: 'IN-POOL - Response Pending: {{job.department.displayName}}',
          body: 'Service request from {{customerName}}: {{job.department.displayName}} on {{job.date}}{{#job.shifts}} / {{from}} - {{to}} {{/job.shifts}}',
        },
        SYS: '',
      },
    },
    [NotificationEnum.TRANSFER_DECLINED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Transfer Declined: {{{job.department.displayName}}}',
          body: {
            introText:
              'The transfer from {{customerName}} has been declined for the following service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Transfer Declined: {{{job.department.displayName}}}',
          body: {
            introText:
              'The transfer from {{customerName}} has been declined for the following service:',
            actionButtonText: 'Go to Service',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_TRANSFER_DECLINED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject:
            'IN-POOL - Transfer Declined: {{{employment.department.displayName}}}',
          body: {
            introText:
              'The transfer from {{customerName}} has been declined for the following assignment:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Transfer Declined: {{{employment.department.displayName}}}',
          body: {
            introText:
              'The transfer from {{customerName}} has been declined for the following assignment:',
            actionButtonText: 'Go to Assignment',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_POSSIBLE_CANDIDATE]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - New Possible Employee',
          body: {
            introText:
              'A possible employee has been submitted for the following assignment:',
            textBeforeAction: 'Accept the desired employee:',
            actionButtonText: 'Go to assignment',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - New Possible Employee',
          body: {
            introText:
              'A possible employee has been submitted for the following assignment:',
            textBeforeAction: 'Accept the desired employee:',
            actionButtonText: 'Go to assignment',
          },
        },
      },
    },
    [NotificationEnum.TRANSFER_EXTERNAL_API_REQUEST_FAILED]: {
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'Service Transmission: {{#job}}{{#department}}{{{displayName}}}{{/department}} on {{date}}{{#shifts}} / {{from}} - {{to}} {{/shifts}}{{/job}}',
          body: {
            introText: `Something went wrong while transferring a service via API. <br />{{customerName}} would like to send you the following service via email:`,
            bookingButtonText: 'Book',
            submitButtonText: 'Submit',
            bookingButtonMessage:
              'To book an employee directly, use the following link:',
            submitButtonMessage:
              'To submit a possible employee, use the following link:',
          },
        },
      },
    },
    [NotificationEnum.TRANSFER]: {
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: '{{{customerName}}} - Service Transmission',
          body: {
            introText:
              '{{customerName}} would like to send you the following service via email:',
            actionButtonText: 'Go to Service',
          },
        },
        PUSH: {
          title: '{{{customerName}}} - Service Transmission',
          body: '{{customerName}} would like to send you the following service',
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'Service Transmission: {{#job}}{{#department}}{{{displayName}}}{{/department}} on {{date}}{{#shifts}} / {{from}} - {{to}} {{/shifts}}{{/job}}',
          body: {
            introText:
              '{{customerName}} would like to send you the following service via email:',
            bookingButtonText: 'To Request',
            submitButtonText: 'To Request',
            bookingButtonMessage:
              'To book or decline a possible employee, use the following link:',
            submitButtonMessage:
              'To submit or decline a possible employee, use the following link:',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_TRANSFER]: {
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject: '{{{customerName}}} - Assignment Transmission',
          body: {
            introText:
              '{{customerName}} would like to send you the following assignment:',
            actionButtonText: 'Go to Assignment',
          },
        },
        PUSH: {
          title: '{{{customerName}}} - Assignment Transmission',
          body: '{{customerName}} would like to send you the following assignment',
        },
      },
      [RecipientEnum.EXTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'Assignment Transmission: {{#employment}}{{#department}}{{{displayName}}}{{/department}} on {{date}}{{#shifts}} / {{from}} - {{to}} {{/shifts}}{{/employment}}',
          body: {
            introText:
              '{{customerName}} would like to send you the following assignment via email:',
            submitButtonText: 'To Request',
            submitButtonMessage:
              'To submit or decline a possible employee, use the following link:',
          },
        },
      },
    },
    [NotificationEnum.AVAILABILITY_UPDATES_REPORT]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'Availability Updates',
          body: {
            introText:
              'Attached you will find the availability of employees that has changed since the last email.',
          },
        },
      },
    },
    [NotificationEnum.TWO_FACTOR_AUTH_PHONE]: {
      [RecipientEnum.USER]: {
        SMS: 'Your code is: {{secret}}',
      },
    },
    [NotificationEnum.TWO_FACTOR_AUTH_EMAIL]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Two-Factor Authentication',
          body: {
            introText:
              'Your code for the two-factor authentication is: {{secret}}',
          },
        },
      },
    },
    [NotificationEnum.EMPLOYMENT_INFORMATION_CHANGED]: {
      [RecipientEnum.USER]: {
        EMAIL: {
          subject: 'IN-POOL - Employment information changed',
          body: {
            introText: 'A temporary employment has changed the following data:',
            actionButtonText: 'To the employment',
          },
        },
      },
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Employment information changed',
          body: {
            introText: 'A temporary employment has changed the following data:',
            actionButtonText: 'To the employment',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Employment information changed',
          body: {
            introText: 'A temporary employment has changed the following data:',
            actionButtonText: 'To the employment',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Employment information changed',
          body: {
            introText: 'A temporary employment has changed the following data:',
            actionButtonText: 'To the employment',
          },
        },
      },
    },
    [NotificationEnum.AUTO_BOOKED_ON_TRANSFER]: {
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Booked {{user.firstName}} {{user.lastName}} on {{job.date}} at {{job.department.displayName}}',
          body: {
            introText:
              'A person has been automatically booked for the following service:',
            actionButtonText: 'To Service',
          },
        },
      },
    },
    [NotificationEnum.AUTO_POSSIBLE_CANDIDATE_ON_TRANSFER]: {
      [RecipientEnum.INTERNAL_TRANSFER_CUSTOMER]: {
        EMAIL: {
          subject:
            'IN-POOL - Possible Candidate {{user.firstName}} {{user.lastName}}',
          body: {
            introText:
              'A person has been automatically submitted for the following service as a possible candidate:',
            actionButtonText: 'To Service',
          },
        },
      },
    },
    [NotificationEnum.JOB_REQUESTED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Service request',
          body: {
            introText:
              'A new service request has been created, please check the request and accept or decline it.',
            actionButtonText: 'To the requests',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Service request',
          body: {
            introText:
              'A new service request has been created, please check the request and accept or decline it.',
            actionButtonText: 'To the requests',
          },
        },
      },
    },
    [NotificationEnum.JOB_RETRACTION_REQUESTED]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Service retraction request',
          body: {
            introText:
              'A request for the retraction of a service has been created. Please check the request and accept or decline it.',
            actionButtonText: 'To the requests',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Service retraction request',
          body: {
            introText:
              'A request for the retraction of a service has been created. Please check the request and accept or decline it.',
            actionButtonText: 'To the requests',
          },
        },
      },
    },
    [NotificationEnum.JOB_REQUEST_ACCEPTED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Job request accepted',
          body: {
            introText:
              'The following job request has been accepted by {{activeUserFirstName}} {{activeUserLastName}}:',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Job request accepted',
          body: {
            introText:
              'The following job request has been accepted by {{activeUserFirstName}} {{activeUserLastName}}:',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Job request accepted',
          body: {
            introText:
              'The following job request has been accepted by {{activeUserFirstName}} {{activeUserLastName}}:',
          },
        },
      },
    },
    [NotificationEnum.JOB_REQUEST_DECLINED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Job request declined',
          body: {
            introText:
              'The following job request has been declined by {{activeUserFirstName}} {{activeUserLastName}}:',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Job request declined',
          body: {
            introText:
              'The following job request has been declined by {{activeUserFirstName}} {{activeUserLastName}}:',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Job request declined',
          body: {
            introText:
              'The following job request has been declined by {{activeUserFirstName}} {{activeUserLastName}}:',
          },
        },
      },
    },
    [NotificationEnum.JOB_RETRACTION_REQUEST_ACCEPTED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Service retraction request accepted',
          body: {
            introText:
              'The service retraction request has been accepted by {{activeUserFirstName}} {{activeUserLastName}}:',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Service retraction request accepted',
          body: {
            introText:
              'The service retraction request has been accepted by {{activeUserFirstName}} {{activeUserLastName}}:',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Service retraction request accepted',
          body: {
            introText:
              'The service retraction request has been accepted by {{activeUserFirstName}} {{activeUserLastName}}:',
          },
        },
      },
    },
    [NotificationEnum.JOB_RETRACTION_REQUEST_DECLINED]: {
      [RecipientEnum.CREATOR]: {
        EMAIL: {
          subject: 'IN-POOL - Service retraction request declined',
          body: {
            introText:
              'The service retraction request has been declined by {{activeUserFirstName}} {{activeUserLastName}}:',
          },
        },
      },
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Service retraction request declined',
          body: {
            introText:
              'The service retraction request has been declined by {{activeUserFirstName}} {{activeUserLastName}}:',
          },
        },
      },
      [RecipientEnum.DEPARTMENT]: {
        EMAIL: {
          subject: 'IN-POOL - Service retraction request declined',
          body: {
            introText:
              'The service retraction request has been declined by {{activeUserFirstName}} {{activeUserLastName}}:',
          },
        },
      },
    },
    [NotificationEnum.NEW_JOB_REQUEST_NEEDS_APPROVAL]: {
      [RecipientEnum.CUSTOMER]: {
        SMS: 'A new job request has been submitted. Please check the request:\n{{actionLink}}',
        EMAIL: {
          subject: 'IN-POOL - New Job Request',
          body: {
            introText:
              'A new job request has been submitted for the following service:',
            textBeforeAction: 'Check the request and accept or reject it:',
            actionButtonText: 'Go to open requests',
          },
        },
      },
    },
    [NotificationEnum.UNMAPPED_PERIGON_JOBS]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Jobs with missing Perigon mapping',
          body: {
            introText:
              'There are {{unmappedJobsCount}} jobs with missing Perigon mapping.',
            unmappedPerigonJobsMessage:
              'Please check the Perigon mappings of the jobs and correct them.',
            actionButtonText: 'To the jobs',
          },
        },
      },
    },
    [NotificationEnum.DISPO_REMOVED_FROM_POOL]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Disponent removed',
          body: {
            introText: 'A Disponent has been removed from the pool.',
          },
        },
      },
    },
    [NotificationEnum.POOLER_REMOVED_FROM_POOL]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Pooler removed',
          body: {
            introText: 'A Pooler has been removed from the pool.',
          },
        },
      },
    },
    [NotificationEnum.REQUESTER_REMOVED_FROM_POOL]: {
      [RecipientEnum.CUSTOMER]: {
        EMAIL: {
          subject: 'IN-POOL - Requester removed',
          body: {
            introText: 'A Requester has been removed from the pool.',
          },
        },
      },
    },
  },
};
